<template>
  <div id="container" v-if="fetch_static">
    <section id="atsuatsu">

      <div v-html="top_body"/>

      <template v-if="fetch_contests && fetch_contests.contests.length > 0 && fetch_contest">
        <div class="container" style="padding: 30px" id="results">
          <select v-model="id" @change="changeContest()">
            <option v-for="contest in fetch_contests.contests" :key="'sel-' + contest.id" :value="contest.id">{{ contest.title }}
            </option>
          </select>
        </div>

        <div class="container" v-if="line_collections_3month">
          <div class="box chart" v-if="line_collections_3month">
            <h3 class="title">3か月グラフ</h3>
            <div class="scrl_wrap">
            <line-chart :chart-data="line_collections_3month" :options="options" style="height: 300px;"/>
            </div>
          </div>
          <div class="box chart" v-if="line_collections_12month">
            <h3 class="title">12か月グラフ</h3>
            <div class="scrl_wrap">
            <line-chart :chart-data="line_collections_12month" :options="options" style="height: 300px;"/>
            </div>
          </div>
        </div>

        <div class="container" v-if="fetch_contest">
          <div class="box list" v-if="fetch_contest.results.user_ranks_3month">
            <h3 class="title">3か月ランキング</h3>
            <p>総エントリー数：{{delimited(fetch_contest.contest.entry_count)}}名</p>
            <div class="contest-status completed" v-if="fetch_contest.results.ranks_3month_completed">
              <span>確定</span>
            </div>
            <div class="contest-status progress" v-else>
              <span>進行中</span>
            </div>
            <div class="scrl_wrap">
              <div class="atsu_tbl_box">
                <table class="point_history ranks-3month">
                  <tbody>
                  <tr class="header">
                    <th class="rank">順位</th>
                    <th class="number">塾生番号</th>
                    <th class="rate">騰落率</th>
                    <th class="ticker">銘柄コード</th>
                    <th class="name">銘柄名</th>
                  </tr>

                  <tr v-for="m in fetch_contest.results.user_ranks_3month" :key="'list-3-' + m.user_number">
                    <td class="rank-value"><p>{{ m.rank && m.rank !== 10000 ? `第${m.rank}位` : '-' }}</p></td>
                    <td class="number-value">
                      <p>
                      <template v-if="m.user_id">
                        <router-link :to="{ name: 'SnsTimeline', params: {user_id: m.user_id}}">
                          {{ Number(m.user_number) }}
                        </router-link>
                      </template>
                      <template v-else>
                        {{ Number(m.user_number) }}
                      </template>
                      </p>
                    </td>
                    <td class="rate-value" v-bind:class="{plus: m.rate >= 0, minus: m.rate < 0}">
                      <p>{{
                          m.rate === 0 ? '±' : m.rate >= 0 ? '+' : ''
                      }}{{ m.rate != null && m.rate !== -10000 ? (Math.round(m.rate * 100) / 100).toFixed(2) + '%' : '-' }}</p>
                    </td>
                    <td class="ticker-value">
                      <p><a :href="'https://shikiho.toyokeizai.net/stocks/' + m.ticker" target="_blank">{{ m.ticker }}</a></p>
                    </td>
                    <td class="name-value">
                      <p><a :href="'https://shikiho.toyokeizai.net/stocks/' + m.ticker" target="_blank">{{ m.stock_name }}</a></p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="moreBtn">
            <router-link :to="{ name: 'AtsuatsuRanking', params: {id: id, month: 3}, query: {atsuatsu_draft: atsuatsu_draft}}" class="">
              全リストはこちら
            </router-link>
            </div>

          </div>
          <div class="box list" v-if="fetch_contest.results.user_ranks_12month">
            <h3 class="title">12か月ランキング</h3>
            <p>総エントリー数：{{delimited(fetch_contest.contest.entry_count)}}名</p>
            <div class="contest-status completed" v-if="fetch_contest.results.ranks_12month_completed">
              <span>確定</span>
            </div>
            <div class="contest-status progress" v-else>
              <span>進行中</span>
            </div>

            <div class="scrl_wrap">
              <div class="atsu_tbl_box">
                <table class="point_history ranks-12month">
                  <tbody>
                  <tr class="header">
                    <th class="rank">順位</th>
                    <th class="number">塾生番号</th>
                    <th class="rate">騰落率</th>
                    <th class="ticker">銘柄コード</th>
                    <th class="name">銘柄名</th>
                  </tr>
                  <tr v-for="m in fetch_contest.results.user_ranks_12month" :key="'list-12-' + m.user_number">
                    <td class="rank-value"><p>{{ m.rank ? `第${m.rank}位` : '-' }}</p></td>
                    <td class="number-value">
                      <p>
                      <template v-if="m.user_id">
                        <router-link :to="{ name: 'SnsTimeline', params: {user_id: m.user_id}}">
                          {{ Number(m.user_number) }}
                        </router-link>
                      </template>
                      <template v-else>
                        {{ Number(m.user_number) }}
                      </template>
                      </p>
                    </td>
                    <td class="rate-value" v-bind:class="{plus: m.rate >= 0, minus: m.rate < 0}">
                     <p> {{
                         m.rate === 0 ? '±' : m.rate >= 0 ? '+' : ''
                      }}{{ m.rate != null  && m.rate !== -10000 ? (Math.round(m.rate * 100) / 100).toFixed(2) + '%' : '-' }}</p>
                    </td>
                    <td class="ticker-value">
                      <p><a :href="'https://shikiho.toyokeizai.net/stocks/' + m.ticker" target="_blank">{{ m.ticker }}</a></p>
                    </td>
                    <td class="name-value">
                      <p><a :href="'https://shikiho.toyokeizai.net/stocks/' + m.ticker" target="_blank">{{ m.stock_name }}</a></p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="moreBtn">
            <router-link :to="{ name: 'AtsuatsuRanking', params: {id: id, month: 12}, query: {atsuatsu_draft: atsuatsu_draft}}" class="">
              全リストはこちら
            </router-link>
            </div>
          </div>
        </div>

        <!-- 全期間-->
        <div class="box list" v-if="fetch_total_ranks && fetch_total_ranks[total_rank].length > 0">
          <form action="">
            <h3 class="title">全期間ランキング</h3>
            <div class="radio">
              <input id="radio-1" type="radio" v-model="total_rank" value="ranks_adv">
              <label for="radio-1">平均</label>
              <input id="radio-2" type="radio" v-model="total_rank" value="ranks_rate">
              <label for="radio-2">最高値</label>
            </div>
          </form>

          <div class="scrl_wrap">
            <div class="atsu_tbl_box">
              <table class="point_history total-ranks">
                <tbody>
                <tr class="header">
                  <th class="rank">順位</th>
                  <th class="number">塾生番号</th>
                  <th class="entry-count">エントリー回数</th>
                  <th class="rate-adv">騰落率</th>
                  <th class="rate-max">最高値</th>
                  <th class="rate-min">最低値</th>
                </tr>

                <tr v-for="m in fetch_total_ranks[total_rank]" :key="'total-list-' + m.user_number">
                  <td class="rank-value">{{ m.rank && m.rank !== 10000 ? `第${m.rank}位` : '-' }}</td>
                  <td class="number-value">
                    <template v-if="m.user_id">
                      <router-link :to="{ name: 'SnsTimeline', params: {user_id: m.user_id}}">
                        {{ Number(m.user_number) }}
                      </router-link>
                    </template>
                    <template v-else>
                      {{ Number(m.user_number) }}
                    </template>
                  </td>
                  <td>{{ m.entry_count }}</td>
                  <td class="rate-adv" v-bind:class="{plus: m.rate_adv >= 0, minus: m.rate_adv < 0}">
                    {{
                      m.rate_adv === 0 ? '±' : m.rate_adv >= 0 ? '+' : ''
                    }}{{ m.rate_adv && m.rate_adv !== -10000 ? (Math.round(m.rate_adv * 100) / 100).toFixed(2) + '%' : '-' }}
                  </td>
                  <td class="rate-max" v-bind:class="{plus: m.rate_max >= 0, minus: m.rate_max < 0}">
                    {{
                      m.rate_max === 0 ? '±' : m.rate_max >= 0 ? '+' : ''
                    }}{{ m.rate_max && m.rate_max !== -10000 ? (Math.round(m.rate_max * 100) / 100).toFixed(2) + '%' : '-' }}
                  </td>
                  <td class="rate-min" v-bind:class="{plus: m.rate_min >= 0, minus: m.rate_min < 0}">
                    {{
                      m.rate_min === 0 ? '±' : m.rate_min >= 0 ? '+' : ''
                    }}{{ m.rate_min && m.rate_min !== -10000 ? (Math.round(m.rate_min * 100) / 100).toFixed(2) + '%' : '-' }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="moreBtn">
          <router-link :to="{name: 'AtsuatsuTotalRanking'}" class="">全リストはこちら</router-link>
          </div>
        </div>
      </template>

      <div v-html="bottom_body"/>

    </section>
    <div id="b_listBox">
      <ul id="b_list">
        <li><a href="/">トップページ</a></li>
        <li><a href="">アツアツ銘柄コンテスト</a></li>
      </ul>
    </div>
  </div><!--//＃container-->
</template>

<script>
import Libraries from '@/components/Libraries.vue'
import LineChart from './LineChart'

const colors = [
  '#4CAF50',
  '#2196F3',
  '#FF9800',
  '#E91E63',
  '#9C27B0',
  '#00BCD4',
  '#8BC34A',
  '#FFC107',
  '#FF5722',
  '#3F51B5'
]

export default {
  mixins: [Libraries],
  components: {
    LineChart
  },
  data() {
    return {
      atsuatsu_draft: this.$route.query.atsuatsu_draft,
      fetch_contests: null,
      fetch_contest: null,
      fetch_total_ranks: null,
      total_rank: 'ranks_adv',
      fetch_static: null,
      top_body: null,
      bottom_body: null,
      id: this.$route.query.id,
      line_collections_3month: null,
      line_collections_12month: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              callback: function (value) {
                return value + '%';
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              console.log(tooltipItem, data.datasets[tooltipItem.datasetIndex])
              const ticker = data.datasets[tooltipItem.datasetIndex].ticker
              const label = data.datasets[tooltipItem.datasetIndex].label
              let price = data.datasets[tooltipItem.datasetIndex].prices[tooltipItem.index]
              price = price ? `${price}円` : '-'
              return [
                `銘柄名: ${label}`,
                `銘柄コード: ${ticker}`,
                `騰落率: ${(Math.round(tooltipItem.yLabel * 100) / 100).toFixed(2)}%`,
                `株価: ${price}`
              ]
            }
          }
        }
      }
    }
  },
  watch: {
    $route(/*to, from*/) {
      this.fetchContest()
    }
  },
  mounted() {
    this.fetchContests()
    this.fetchTotalRanks()
  },
  methods: {
    changeContest() {
      this.$router.push({name: 'AtsuatsuLp', query: {id: this.id, atsuatsu_draft: this.atsuatsu_draft}, hash: '#results'})
    },
    fetchTotalRanks() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}stock_contest/total_ranks.json`, {
            params: {
              rank_count: 5
            }
          })
          .then(response => {
            // TODO: 一旦非表示
            this.fetch_total_ranks = response.data
            this.fetch_total_ranks = null
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },
    fetchContests() {
      this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}stock_contest/contests.json`, {
            params: {
              draft: this.atsuatsu_draft
            }
          })
          .then(response => {
            this.fetch_contests = response.data
            if (this.fetch_contests && this.fetch_contests.contests.length > 0) {
              if (!this.id) {
                this.id = this.fetch_contests.contests[0].id
              }
              this.fetchContest()
            }
            if (!this.fetch_static) {
              this.fetchStatic()
            }
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            this.finishAjax()
          })
    },

    fetchContest() {
      // this.startAjax()
      this.line_collections_3month = this.line_collections_12month = null
      this.axios
          .get(`${this.env.api_base_url}stock_contest/contest.json`, {
            params: {
              id: this.id,
              rank_count: 5,
              draft: this.atsuatsu_draft
            }
          })
          .then(response => {
            this.fetch_contest = response.data
            if (this.fetch_contest.results.stock_collections_3month) {
              let index = 0
              for (const m of this.fetch_contest.results.stock_collections_3month.datasets) {
                m.backgroundColor = colors[index]
                m.borderColor = colors[index++]
                m.lineTension = 0
                m.fill = false
              }
            }
            this.line_collections_3month = this.fetch_contest.results.stock_collections_3month

            if (this.fetch_contest.results.stock_collections_12month) {
              let index = 0
              for (const m of this.fetch_contest.results.stock_collections_12month.datasets) {
                m.backgroundColor = colors[index]
                m.borderColor = colors[index++]
                m.lineTension = 0
                m.fill = false
              }
            }
            this.line_collections_12month = this.fetch_contest.results.stock_collections_12month

            if (location.hash) {
              this.$nextTick(() => {
                this.scrollTo('#results')
              });
            }
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            // this.finishAjax()
          })
    },

    fetchStatic() {
      if (this.$route.query.reg) {
        this.uri = this.$route.query.reg === '1' ? 'lp_atsuatsu_registrable' : 'lp_atsuatsu_standby'
      } else {
        this.uri = this.fetch_contests.contest_period ? 'lp_atsuatsu_registrable' : 'lp_atsuatsu_standby'
      }

      // this.startAjax()
      this.axios
          .get(`${this.env.api_base_url}contents.json`, {
            params: {
              uri: this.uri,
              draft: this.$route.query.draft
            },
          })
          .then(response => {
            this.fetch_static = response.data
            this.setMeta({
              title: this.fetch_static.title,
              description: this.fetch_static.description,
            })

            // mashup point
            const index = this.fetch_static.body.indexOf('<!-- results -->')
            if (index === -1) {
              this.fetch_contests = null
              this.top_body = this.fetch_static.body
              this.bottom_body = ''
            } else {
              this.top_body = this.fetch_static.body.substring(0, index + 16)
              this.bottom_body = this.fetch_static.body.substring(index + 16, this.fetch_static.body.length)
            }
          })
          .catch((response) => {
            this.errorAjax(response)
          })
          .finally(() => {
            // this.finishAjax()
            if (location.hash) {
              setTimeout(() => {
                this.scrollTo(location.hash)
              }, 200)
            }
            // user js への onload処理
            if (typeof _million_onload !== 'undefined') {
              window._million_onload(this.fetch_static.uri);
            }
          })
    }
  }
}
</script>

<style lang="scss">
.container {
  display: flex;
}

.box {
  flex: 1;
  padding: 0 30px 0 30px;

  &.list {
    margin-bottom: 30px;

    .minus {
      color: red;
    }

    th {
      &.rank {
        width: 14%;
      }

      &.number {
        width: 20%;
      }

      &.rate {
        width: 18%;
      }

      &.ticker {
        width: 18%;
      }

      &.name {
        width: 30%;
      }
    }
  }

  .contest-status {
    text-align: right;
    margin-bottom: 20px;
    color: white;

    span {
      display: inline-block;
      text-align: center;
      width: 100px;
      padding: 5px 10px 5px 10px;
      border-radius: 20px;
    }

    &.completed {
      span {
        background: red;
      }
    }

    &.progress {
      span {
        background: green;
      }
    }
  }
}
</style>